var _Checkmark;
import Checkmark from '@crehana/compass.icons.outline/Checkmark';
import { cn } from '@crehana/compass.ui/v2';

// DropdownListItemsDefault

// import { DropdownListItemsDefault } from '@crehana/compass.ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ItemList = function ItemList(_ref) {
  var items = _ref.items,
    selectedItem = _ref.selectedItem,
    onSelectItem = _ref.onSelectItem,
    _ref$showCategoryIcon = _ref.showCategoryIcon,
    showCategoryIcon = _ref$showCategoryIcon === void 0 ? false : _ref$showCategoryIcon,
    renderCategoryIcon = _ref.renderCategoryIcon,
    className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    className: cn('tw-max-h-[13.2rem] tw-w-full tw-mt-0.8 tw-overflow-y-auto', className),
    children: items.map(function (item) {
      return /*#__PURE__*/_jsxs("div", {
        role: "button",
        tabIndex: 0,
        className: cn('tw-w-full tw-py-[0.6rem] tw-flex tw-items-center tw-gap-1.2 tw-mb-0.4 tw-cursor-pointer hover:tw-bg-neutral-light-200 tw-px-2.4', {
          'tw-bg-neutral-light-200': (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) === item.label
        }),
        onClick: function onClick() {
          return onSelectItem(item);
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            onSelectItem(item);
          }
        },
        children: [showCategoryIcon && renderCategoryIcon && renderCategoryIcon(item.category) && /*#__PURE__*/_jsx("div", {
          className: "tw-p-0.2 tw-flex tw-items-center tw-justify-center tw-rounded-0.4 tw-bg-neutral-light-400",
          children: renderCategoryIcon(item.category)
        }), /*#__PURE__*/_jsx("p", {
          className: "tw-font-body5 tw-text-neutral-light-800",
          children: item.label
        }), (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) === item.label && (_Checkmark || (_Checkmark = /*#__PURE__*/_jsx(Checkmark, {
          size: 16,
          className: "tw-text-success-400 tw-ml-auto"
        })))]
      }, "item-".concat(item.label));
    })
  });
};